import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faTimes } from "@fortawesome/free-solid-svg-icons";
import logo from "../../assets/image/logo.png";
import { Link, useLocation } from "react-router-dom";
import SidebarDropdown from "./SidebarDropdown";
import SidebarSubItem from "./SidebarSubItem";
import { HashLink } from 'react-router-hash-link';

function Navbar() {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    return (
        <>
            {/* NAVBAR */}
            <nav className="fixed top-0 left-0 right-0 flex justify-between items-center px-5 py-7 md:py-10 z-20">
                <div className="flex items-center gap-3">
                    {/* Ícono del menú */}
                    <FontAwesomeIcon
                        icon={isOpen ? faTimes : faBars}
                        className="w-6 h-6 text-white cursor-pointer"
                        onClick={() => setIsOpen(!isOpen)}
                    />
                    <Link to={'/'}>
                        <img src={logo} alt="" className="w-32" />
                    </Link>

                </div>

                {/* Acciones desktop */}
                <div className="max-md:hidden flex items-center gap-3 md:w-[300px]">
                    <HashLink className="btn-outline w-full text-white hover:text-[#eeb500] no-underline"
                       to='/#planes'>
                        PLANES
                    </HashLink>
                    <HashLink className="btn-primary w-full text-white no-underline"
                        to="/descarga/#inicio">
                        DESCARGAR
                    </HashLink>
                </div>
            </nav>

            {/* SIDEBAR IZQUIERDO */}
            <AnimatePresence>
                {isOpen && (
                    <motion.aside
                        initial={{ x: "-100%" }}
                        animate={{ x: 0 }}
                        exit={{ x: "-100%" }}
                        transition={{ duration: 0.3 }}
                        className="fixed top-0 left-0 h-full w-[300px] bg-black z-40 px-6 py-8 overflow-y-auto"
                    >
                        {/* Logo + X */}
                        <div className="flex justify-between items-center mb-10">
                            <img src={logo} alt="logo" className="w-32" />
                            <FontAwesomeIcon
                                icon={faTimes}
                                className="w-6 h-6 text-white cursor-pointer"
                                onClick={() => setIsOpen(false)}
                            />
                        </div>

                        {/* ITEMS PRINCIPALES */}
                        <div className="text-white text-[15px] font-light tracking-wide">

                            {/** ITEM */}
                            <SidebarItem label="RENOVAR" url='/renovar#inicio' />

                            <SidebarItem label="PLANES" url='/#planes' />

                            <SidebarItem label="RESELLER" url='/reseller#inicio' />

                            <SidebarItem label="DESCARGAR" url='/descarga#inicio'/>

                            {/* ITEM CON SUBMENÚ */}
                            <SidebarDropdown label="INSTALAR EN">
                                <SidebarSubItem label="SMART TV" url='/smart-tv#inicio'/>
                                <SidebarSubItem label="TV BOX" url='/tv-box#inicio'/>
                                <SidebarSubItem label="FIRE STICK" url='/fire-stick#inicio'/>
                                <SidebarSubItem label="PC & MAC" url='/pc-mac#inicio'/>
                            </SidebarDropdown>

                            <SidebarItem label="DUDAS" url='/#fag'/>
                        </div>
                    </motion.aside>
                )}
            </AnimatePresence>


            {/* OVERLAY oscuro para cerrar el menú */}
            <AnimatePresence>
                {isOpen && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 0.5 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.3 }}
                        className="fixed inset-0 bg-black z-20"
                        onClick={() => setIsOpen(false)}
                    />
                )}
            </AnimatePresence>
        </>
    );
}

export default Navbar;

function SidebarItem({ label,url }) {
    return (
        <HashLink to={url}>
        <div className="py-4 border-b border-white/20 cursor-pointer">
            {label}
        </div>
        </HashLink>
    );
}
